import { render, staticRenderFns } from "./Analisis_total_ganado.vue?vue&type=template&id=37ea2fb6"
import script from "./Analisis_total_ganado.vue?vue&type=script&lang=js"
export * from "./Analisis_total_ganado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports